var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.25L9 5.25L5.25 2.25M5.1 15.75H12.9C14.1602 15.75 14.7901 15.75 15.2715 15.5048C15.6949 15.2891 16.0391 14.9449 16.2548 14.5215C16.5 14.0401 16.5 13.4102 16.5 12.15V8.85C16.5 7.58985 16.5 6.95982 16.2548 6.47852C16.0391 6.05516 15.6949 5.71095 15.2715 5.49524C14.7901 5.25 14.1602 5.25 12.9 5.25H5.1C3.83988 5.25 3.20982 5.25 2.72852 5.49524C2.30516 5.71095 1.96095 6.05516 1.74524 6.47852C1.5 6.95982 1.5 7.58985 1.5 8.85V12.15C1.5 13.4102 1.5 14.0401 1.74524 14.5215C1.96095 14.9449 2.30516 15.2891 2.72852 15.5048C3.20982 15.75 3.83988 15.75 5.1 15.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreaming);
export default __webpack_public_path__ + "static/media/streaming.526d72d975037afce7c06e813da407de.svg";
export { ForwardRef as ReactComponent };